import React from "react";
import "./css/BoxIcon.scss";

const BoxIcon = ({ objContainer }) => {
  return (
    <div className='box-icon'>
      <div className='icon'>
        <img src={objContainer.icon} alt='icon'></img>
      </div>
      <div className='title'>{objContainer.title}</div>
      <div className='text'>{objContainer.text}</div>
    </div>
  );
};

export default BoxIcon;
